export default __webpack_public_path__ + "static/media/Resources.bdd2ea98.svg";